import "./AppointmentsCertificationAndConsentFormViewComponent.scss";
import React from "react";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import {CommonService} from "../../../../../shared/services";

interface AppointmentsCertificationAndConsentFormViewComponentProps {
    consentDetails?: any;
}

const AppointmentsCertificationAndConsentFormViewComponent = (props: AppointmentsCertificationAndConsentFormViewComponentProps) => {
    const {consentDetails} = props;

    return (
        <div className={'appointments-certification-and-consent-form-view-component'}>
            <div className={'appointments-form-view'}>
                <div className={'appointments-form-view-title'}>Certification and Consent</div>
                <div className={'appointments-form-view-details-wrapper'}>
                    <div className={'appointments-form-view-details-text'}>
                        I hereby certify that I have completed this form to the best of my ability and I acknowledge
                        that all the information that I have
                        supplied on this form is true, accurate, current, and complete.
                    </div>
                    <div className={'appointments-form-view-details-text'}>
                        I understand that my medical history is a very important factor in the direction of my care.
                        Medical or physical conditions which are known to me, but which I do not disclose on this form
                        or to my provider, may result in serious injury to me. If any of the above conditions change, I
                        will immediately inform Kinergy Sports Medicine and Performance or my provider. I knowingly and
                        willingly
                        assume all risks of injury resulting from my failure to disclose accurate, complete and updated
                        information in accordance with the above questionnaire.
                    </div>
                    <div className={'appointments-form-view-details-text'}>
                        I hereby consent to and authorize Kinergy Sports Medicine and Performance to perform any medical
                        assessments and treatments deemed necessary for my medical care. I understand and am informed
                        that,
                        as in the practice of medicine, rehabilitation therapy may have some risks. I understand that I
                        have
                        the right to ask about these risks and have any questions about my conditions answered prior to
                        treatment. I understand that at any time, except retrospectively, I may revoke this consent. I
                        acknowledge that no guarantee or assurance has been made to me as to the results of the care I
                        will
                        receive.
                    </div>
                    <div className={'appointments-form-view-details-text'}>
                        I acknowledge that I have read and agree to the statement as written above.
                    </div>
                    {
                        consentDetails?.is_authorized_representative && <div className={'appointments-form-view-details-text'}>
                            I am an Authorized Representative for the client (ie. Parent, Legal Guardian, Agent, Manager, etc.)
                        </div>
                    }
                    <div className={'ts-row'}>
                        <div className={'ts-col-md-6'}>
                            <DetailsDataKeyValueComponent title={"Client Name"}>
                                {consentDetails?.client_name || 'NA'}
                            </DetailsDataKeyValueComponent>
                        </div>
                        <div className={'ts-col-md-6'}>
                            <DetailsDataKeyValueComponent title={"Date"}>
                                {consentDetails?.date ? CommonService.convertDateFormat2(consentDetails?.date) : 'NA'}
                            </DetailsDataKeyValueComponent>
                        </div>
                    </div>
                    {
                        consentDetails?.is_authorized_representative &&  <DetailsDataKeyValueComponent title={"Authorized Representative Name"}>
                            {consentDetails?.representative_name || 'NA'}
                        </DetailsDataKeyValueComponent>

                    }
                    <DetailsDataKeyValueComponent title={"Signature of Client or Authorized Representative"}>
                        <div className={'signature-image-preview'}>
                            <img src={consentDetails?.signature} alt={"signature"}/>
                        </div>
                    </DetailsDataKeyValueComponent>
                </div>
            </div>
        </div>
    );

};

export default AppointmentsCertificationAndConsentFormViewComponent;
